export default "__VITE_ASSET__8e4a8c21__"